import React, { useState } from 'react'
import clsx from 'clsx'
import { Autocomplete } from '@material-ui/lab'
import {
  TextField,
  FormControl,
  InputAdornment,
  IconButton,
} from '@material-ui/core'
import { ReactComponent as AutocompleteIcon } from '../../../images/autocomplete-icon.svg'
import useStyles from './FormFieldsStyle'

export default function DoubleAutocomplete({ field, values, errors }) {
  const classes = useStyles()
  const [firstOpen, setFirstOpen] = useState(false)
  const [secondOpen, setSecondOpen] = useState(false)

  return (
    <div className={classes.flex}>
      {field.autocompletes.map((autocomplete, i) => (
        <FormControl
          fullWidth
          className={classes.withMargin}
          variant="outlined"
        >
          <div className={classes.inputLabel} shrink>
            {autocomplete.label}
          </div>
          <Autocomplete
            options={autocomplete.options || []}
            loadingText={<span style={{ color: 'white' }}>Loading...</span>}
            noOptionsText={<span style={{ color: 'white' }}>No options</span>}
            open={i === 0 ? firstOpen : secondOpen}
            onOpen={() => (i === 0 ? setFirstOpen(true) : setSecondOpen(true))}
            onClose={() =>
              i === 0 ? setFirstOpen(false) : setSecondOpen(false)
            }
            getOptionLabel={(option) => {
              if (option.name) {
                return option.name
              }
            }}
            classes={{
              option: classes.selectOption,
              paper: classes.selectPaper,
            }}
            renderOption={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  className: clsx(
                    params.InputProps.className,
                    {
                      [classes.inputFont]: !values[autocomplete.key],
                    },
                    classes.inputRoot
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className={classes.iconButton}
                        onMouseDown={(event) => {
                          event.preventDefault()
                          i === 0
                            ? setFirstOpen((prevOpen) => !prevOpen)
                            : setSecondOpen((prevOpen) => !prevOpen)
                        }}
                      >
                        <AutocompleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                placeholder={autocomplete.hint}
                variant="outlined"
                className={classes.customBorder}
                disabled={autocomplete.disabled}
              />
            )}
            name={autocomplete.key}
            value={autocomplete.value ?? values[autocomplete.key]}
            onChange={(evt, value) => {
              delete errors[autocomplete.key]
              autocomplete.onChange(value)
            }}
            multiple={autocomplete.multiple}
            freeSolo={autocomplete.freeSolo}
            disabled={autocomplete.disabled}
            className={clsx(
              classes.fullFlexWidth,
              i === 0 && classes.withRightMargin,
              classes.centerText
            )}
          />
        </FormControl>
      ))}
    </div>
  )
}
